import { useTranslation } from "@atlas/sdk";

interface IMicroFrontendLoadingFallbackProps {
  label: string;
}

export function MicroFrontendLoadingFallback({
  label,
}: IMicroFrontendLoadingFallbackProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 items-center justify-center min-h-[400px]">
      <p className="text-muted-foreground text-sm">
        {t("hub.mfe.loading", {
          label,
          defaultValue: "Loading {{label}}...",
        })}
      </p>
    </div>
  );
}
